import { Packaging } from '@instamenu/data-access';
import { Box, Flex, Label, RadioButton, Text } from '@instamenu/ui-system-next';
import { palette } from '@instamenu/ui-vanilla-extract';
import { Order } from '@instamenu/context-checkout';

export const PackagingOptions = ({ order }: { order: Order }) => (
  <Box>
    <Text variant="caption1" css={{ color: palette.gray600, paddingBottom: 8 }}>
      Order packaging
    </Text>
    <Flex style={{ gap: 32 }}>
      <Label css={{ cursor: 'pointer', display: 'flex', gap: 8, alignItems: 'center' }}>
        <RadioButton
          checked={order.packaging === Packaging.DineIn}
          name="packaging"
          onChange={() => order.editPackaging({ packaging: Packaging.DineIn })}
        />
        <span>For Here</span>
      </Label>
      <Label css={{ cursor: 'pointer', display: 'flex', gap: 8, alignItems: 'center' }}>
        <RadioButton
          checked={order.packaging === Packaging.ToGo}
          name="packaging"
          onChange={() => order.editPackaging({ packaging: Packaging.ToGo })}
        />
        <span>To Go</span>
      </Label>
    </Flex>
  </Box>
);
